import { render, staticRenderFns } from "./MenuInfScroll.vue?vue&type=template&id=0ae08c2e&scoped=true&"
import script from "./MenuInfScroll.vue?vue&type=script&lang=js&"
export * from "./MenuInfScroll.vue?vue&type=script&lang=js&"
import style0 from "./MenuInfScroll.vue?vue&type=style&index=0&id=0ae08c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae08c2e",
  null
  
)

export default component.exports